import React, { useEffect, useState } from "react";

import 'bootstrap/dist/css/bootstrap.min.css';
import { Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import Footer from "./footer";
import Header from "./header";
import { listtimetabledet, slotslist, stuacademicyearlist, studentview, teacherdashboardcount } from "../service/dashboard";

const TimeTable = () => {
    const [ayear, setAYear] = useState("");
    const [ylist, setYList] = useState([]);
    const days = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
    const dayFullNames = {
        Mon: "Monday",
        Tue: "Tuesday",
        Wed: "Wednesday",
        Thu: "Thursday",
        Fri: "Friday",
        Sat: "Saturday",
        Sun: "Sunday"
    };
    const currentDayIndex = new Date().getDay();
    const adjustedIndex = (currentDayIndex + 6) % 7;
    const currentDay = days[adjustedIndex];
    const [activeDay, setActiveDay] = useState(currentDay);
    const [periods, setPeriod] = useState([]);

    useEffect(() => {
        if (localStorage.getItem("Role") === "4") {
            studentview(localStorage.getItem("UID")).then((res1) => {
                if (res1.status === true) {
                    const temp1 = new FormData();
                    temp1.append("academy_id", res1.data.details.academy_id);
                    temp1.append("class", res1.data.details.class_id);
                    temp1.append("section", res1.data.details.section_id);
                    temp1.append("year", res1.data.details.academicyear);

                    listtimetabledet(temp1).then((res) => {
                        if (res.status === true) {
                            let timetableData = res.data;

                            const mergedPeriods = periods.map((period) => {
                                const dayEntry = timetableData.find(
                                    (item) => item.period === period.id && item.day == dayFullNames[activeDay]
                                );
                                return {
                                    ...period,
                                    day: {
                                        [activeDay]: dayEntry || null
                                    }
                                };
                            });
                            setPeriod([...mergedPeriods]);
                        }
                    })
                }
            });
        } else {
            const temp1 = new FormData();
            temp1.append("academy_id", localStorage.getItem("academy"));
            stuacademicyearlist(temp1).then((res) => {
                if (res.status === true) {
                    const sortedYears = [...res.data].sort(
                        (a, b) => Number(b.id) - Number(a.id)
                    );
                    setYList(sortedYears);
                    if (sortedYears.length > 0) {
                        const defaultYear = sortedYears[0].id;
                        listall(defaultYear, activeDay);
                    }
                }
            });
        }

        listall(ayear, activeDay);

    }, []);

    function errorhandle(ev) {
        ev.target.src = require("../assets/images/placeholder.png");
        ev.target.onerror = null;
    }

    // function listall(lyear, lday) {
    //     setPeriod([]);
    //     setAYear(lyear);
    //     setActiveDay(lday);
    //     if (localStorage.getItem("Role") === "5") {
    //         const temp = new FormData();
    //         temp.append("user_id", localStorage.getItem("UID"));
    //         temp.append("year", lyear);
    //         teacherdashboardcount(temp).then((res) => {
    //             if (res.status === true) {
    //                 if (res.data.timetable.length > 0) {
    //                     const filteredTimetable = res.data.timetable.filter(item => item.day == dayFullNames[lday]);//dayFullNames[activeDay]
    //                     const updatedTimetable = filteredTimetable.map((item) => {
    //                         return {
    //                             ...item,
    //                         };
    //                     });
    //                     setPeriod(updatedTimetable);
    //                 }
    //             }
    //         })
    //     } else if (localStorage.getItem("Role") === "4") {
    //         studentview(localStorage.getItem("UID")).then((res1) => {
    //             if (res1.status === true) {
    //                 const temp1 = new FormData();
    //                 temp1.append("academy_id", res1.data.details.academy_id);
    //                 temp1.append("class", res1.data.details.class_id);
    //                 temp1.append("section", res1.data.details.section_id);
    //                 temp1.append("year", res1.data.details.academicyear);


    //                 listtimetabledet(temp1).then((res) => {
    //                     if (res.status === true) {
    //                         let timetableData = res.data;

    //                         slotslist(temp1).then((res1) => {
    //                             if (res1.status === true) {
    //                                 const allPeriods = res1.data;
    //                                 const mergedPeriods = allPeriods.map((period) => {
    //                                     const entry = timetableData.find(
    //                                         (item) => item.period === period.id && item.day === dayFullNames[lday]
    //                                     );
    //                                     return {
    //                                         ...period,
    //                                         subject_name: entry?.subject_name || null,
    //                                         teacher_name: entry?.teacher_name || null,
    //                                         class_name: entry?.class_name || null,
    //                                         section_name: entry?.section_name || null,
    //                                         path: entry?.path || null,
    //                                         photo: entry?.photo || null
    //                                     };
    //                                 });

    //                                 setPeriod(mergedPeriods);
    //                             }
    //                         });


    //                         // const filteredTimetable = res.data.filter(item => item.day == dayFullNames[lday]);//dayFullNames[activeDay]
    //                         // const updatedTimetable = filteredTimetable.map((item) => {
    //                         //     return {
    //                         //         ...item,
    //                         //     };
    //                         // });

    //                         // setPeriod(updatedTimetable);
    //                     }
    //                 })
    //             }
    //         });
    //     }

    // }
const listall = async (lyear, lday) => {

    setPeriod([]);
    setAYear(lyear);
    setActiveDay(lday);

    try {

        if (localStorage.getItem("Role") === "5") {

            const temp = new FormData();
            temp.append("user_id", localStorage.getItem("UID"));
            temp.append("year", lyear);

            const res = await teacherdashboardcount(temp);

            if (res.status === true) {

                if (res.data.timetable.length > 0) {

                    const filteredTimetable = res.data.timetable
                        .filter(item => item.day === dayFullNames[lday])
                        .sort((a, b) => Number(a.period) - Number(b.period));

                    setPeriod(filteredTimetable);
                }
            }

        } else if (localStorage.getItem("Role") === "4") {

            const res1 = await studentview(localStorage.getItem("UID"));

            if (res1.status === true) {

                const temp1 = new FormData();

                temp1.append("academy_id", res1.data.details.academy_id);
                temp1.append("class", res1.data.details.class_id);
                temp1.append("section", res1.data.details.section_id);
                temp1.append("year", res1.data.details.academicyear);

                const timetableRes = await listtimetabledet(temp1);

                if (timetableRes.status) {

                    const timetableData = timetableRes.data;

                    const slotsRes = await slotslist(temp1);

                    if (slotsRes.status) {

                        const allPeriods = slotsRes.data;

                        const mergedPeriods = allPeriods.map((period) => {

                            const entry = timetableData.find(
                                (item) =>
                                    item.period === period.id &&
                                    item.day === dayFullNames[lday]
                            );

                            return {
                                ...period,
                                subject_name: entry?.subject_name || null,
                                teacher_name: entry?.teacher_name || null,
                                class_name: entry?.class_name || null,
                                section_name: entry?.section_name || null,
                                path: entry?.path || null,
                                photo: entry?.photo || null,
                            };
                        });

                        setPeriod(mergedPeriods);
                    }
                }
            }
        }

    } catch (error) {
        console.log(error);
    }
};
    return (
        <div id="mainpage">
            <div className="maincontent">
                <Header />
                <div className="moreheading">
                    <Row className="row-sm">
                        <div className="col-4 pr-0 text-left align-self-end">
                            <h4 className="morehead-text">Time Table</h4>
                        </div>

                        <div className="col-8 pl-0 text-right align-self-end">
                            <Link to={"/dashboard"} className="btn-outline-success red-btn btn-sm">
                                <i className="fa-solid fa-hand-point-left"></i> Go Back
                            </Link>
                        </div>
                    </Row>
                </div>
                {localStorage.getItem("Role") === "5" &&
                    <div className="row">
                        <div className="col-sm-12 col-md-12 col-lg-6 col-xl-4">
                            <div className="mb-3">
                                <label className="form-label">
                                    Academic Year<span className="text-danger"> *</span>
                                </label>
                                <select
                                    className="default-select  form-control wide"
                                    value={ayear}
                                    onChange={(e) =>
                                        listall(e.target.value, activeDay)
                                    }
                                >
                                    <option value="" disabled>
                                        Select Academic Year
                                    </option>
                                    {ylist.map((item, i) => {
                                        return (
                                            <option value={item.id} key={i}>
                                                {item.aca_year}
                                            </option>
                                        );
                                    })}
                                </select>
                            </div>
                        </div>
                    </div>
                }

                <div className="day-tab-bar d-flex justify-content-center gap-2 mb-4">
                    {days.map((day) => (
                        <button
                            key={day}
                            className={`day-tab-btn ${day === activeDay ? "active" : ""}`}
                            value={activeDay}
                            onClick={() => listall(ayear, day)}
                        >
                            {day}
                        </button>
                    ))}
                </div>

                <h6 className="text-center text-muted mb-3">{dayFullNames[activeDay]}</h6>
                {periods.length == 0 && <div className="text-center text-danger">No TimeTable Found</div>}
                {periods.map((item, index) => (
                    <div className="row align-items-stretch mb-3" key={index}>
                        <div className="col-2 d-flex justify-content-center position-relative">
                            <div className="timeline-line"></div>
                            <div className="hour-circle text-white fw-bold">{index + 1}</div>
                        </div>

                        <div
                            className={`col-10 rounded-3 p-3 ${item.is_break === "Yes"
                                ? "bg-light text-dark fw-bold"
                                : "bg-primary-subject text-white"
                                }`}
                        >
                            <div className="d-flex justify-content-between align-items-center">
                                <div className="me-3">
                                    <div className="fw-bold">{item.from_time} - {item.to_time} ({item.name})</div>
                                    {item.is_break === "No" ? (
                                        <>
                                            <div>Subject: {item.subject_name}</div>
                                            {localStorage.getItem("Role") === "4" &&
                                                <div>
                                                    Teacher: {item.teacher_name}
                                                </div>
                                            }
                                            {localStorage.getItem("Role") === "5" &&
                                                <div>
                                                    Class: {item.class_name} | Division: {item.section_name}
                                                </div>
                                            }
                                        </>
                                    ) : (
                                        <div>{""}</div>
                                    )}
                                </div>
                                {localStorage.getItem("Role") === "4" && item.is_break === "No" &&
                                    <img
                                        src={item.path + item.photo}
                                        // {require("../assets/images/placeholder.png")}
                                        alt="Subject"
                                        className="img-fluid rounded-circle"
                                        style={{ width: "60px", height: "60px", objectFit: "cover" }}
                                        onError={errorhandle}
                                    />
                                }

                            </div>
                        </div>
                    </div>
                ))}

            </div>
            <Footer />
        </div>
    );
};

export default TimeTable;
